import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SearchResult from './search-result';

const SearchResults = ({
  searchResults,
  customEntity,
  onSelectEntityClick,
  searchTerm,
}) => {
  const [showMoreEnabled, setShowMoreEnabled] = useState(false);
  if (!searchResults) {
    return (
      <div className='padding-top-less padding-bottom-less color-alert'>Sorry, no {customEntity.name} matches.</div>
    );
  }

  const firstTen = searchResults.slice(0, 10);

  const handleShowMore = () => {
    setShowMoreEnabled(true);
  };

  const handleShowLess = () => {
    setShowMoreEnabled(false);
  };

  const resultsToRender = () => {
    return showMoreEnabled ? searchResults : firstTen;
  };

  return (
    <div className='text-center'>
      <ul className='entityinput-searchresults padding-top'>
        {resultsToRender().map((result) => {
          return (
            <SearchResult
              result={result}
              resultType={customEntity.type}
              onSelectEntityClick={onSelectEntityClick}
              searchTerm={searchTerm}
              isEsri={customEntity.type === 'EsriCustomEntity'}
            />
          );
        })}
      </ul>
      {searchResults.length > 10 && (
        <button type='button' className='btn-link' onClick={showMoreEnabled ? handleShowLess : handleShowMore}>
          {showMoreEnabled ? 'Show Less' : 'Show More'}
        </button>
      )}
    </div>
  );
};

SearchResults.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.shape({})),
  customEntity: PropTypes.shape({
    type: PropTypes.string.isRequired,
  }).isRequired,
  onSelectEntityClick: PropTypes.func,
  searchTerm: PropTypes.string,
};

SearchResults.defaultProps = {
  onSelectEntityClick: () => { },
};

export default SearchResults;
